import { COLOR } from 'vars/index'

export const NavBarBackground = {
  BACKGROUND_DARK: COLOR.BACKGROUND_DARK,
  SURFACE_DARK_6: COLOR.SURFACE_DARK_6,
} as const
export type NavBarBackground =
  (typeof NavBarBackground)[keyof typeof NavBarBackground]

export const NavBarDirection = {
  COLUMN: 'column',
  ROW: 'row',
} as const
export type NavBarDirection =
  (typeof NavBarDirection)[keyof typeof NavBarDirection]

export const NavBarAlignItems = {
  Start: 'start',
  Center: 'center',
  End: 'end',
} as const
export type NavBarAlignItems =
  (typeof NavBarAlignItems)[keyof typeof NavBarAlignItems]

export const NavBarSize = {
  SIZE_50: '56px',
} as const
export type NavBarSize = (typeof NavBarSize)[keyof typeof NavBarSize]

export const NavBarFormation = {
  Dynamic: 'Dynamic',
  Static: 'Static',
} as const
export type NavBarFormation =
  (typeof NavBarFormation)[keyof typeof NavBarFormation]

export const NavBarSearchPosition = {
  Left: 'left',
  Right: 'right',
  None: 'none',
} as const
export type NavBarSearchPosition =
  (typeof NavBarSearchPosition)[keyof typeof NavBarSearchPosition]

export const NavBarBackgroundOverlay = {
  Default: COLOR.SURFACE_OPACITY_DARK_40,
  Hovered: COLOR.OVERLAY_HOVERED,
  Pressed: COLOR.OVERLAY_PRESSED,
} as const
export type NavBarBackgroundOverlay =
  (typeof NavBarBackgroundOverlay)[keyof typeof NavBarBackgroundOverlay]
